import { useState } from 'react';

const faqs = [
  {
    q: '51网址导航和普通导航网站有什么区别？',
    a: '51网址导航不仅提供网址导航123、123导航、导航123等数字标识快捷入口，还聚合了全网热点事件、吃瓜资讯和网友热议内容。相比传统导航网站只提供链接列表，我们更像一个"上网入口 + 资讯聚合"的综合平台，让你打开一个页面就能同时完成找网站和看热点的需求。',
  },
  {
    q: '网址123是什么意思？如何使用？',
    a: '网址123是51网址导航的核心设计理念——"123"代表简单三步：打开页面、找到入口、点击直达。我们精选了最常用的200+网站，按照购物、视频、社交、工具等分类整理，配合数字标识导航（如123导航、导航123），让你无需记忆复杂网址，三步完成上网导航。',
  },
  {
    q: '网站收录的站点安全吗？会不会有广告或跳转？',
    a: '所有收录站点均经过人工审核筛选，确保来源正规。我们坚决杜绝恶意跳转、弹窗广告和钓鱼网站，只为用户提供纯净安全的上网导航体验。如果你发现任何异常站点，欢迎通过"联系我们"模块反馈，我们会在24小时内核实处理。',
  },
  {
    q: '51网址导航需要注册登录吗？是否收费？',
    a: '完全不需要！51网址导航对所有用户永久免费开放，无需注册、无需登录、无需安装任何软件。打开浏览器访问即可使用全部功能。我们坚持"零门槛上网导航"的理念，让每一位用户都能轻松便捷地享受服务。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-[480px] mx-auto">
            关于51网址导航，你可能想了解的问题
          </p>
        </div>

        <div className="max-w-[720px] mx-auto space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 cursor-pointer text-left"
              >
                <h3 className="font-semibold text-sm md:text-base text-foreground-900 pr-4">
                  {faq.q}
                </h3>
                <i
                  className={`flex-shrink-0 text-foreground-400 transition-transform duration-200 text-lg ${
                    openIndex === i ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}